import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { getBusinessLine } from "@payment-client/helpers/Misc";

export const onEmiSelectionScreenView = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: {
        cartId: string;
        planId: string;
        couponCode?: string;
        couponApplied?: boolean;
        withSplitPay: boolean;
        billTotal: number;
    },
): void => {
    impressionEvent({
        category: SCREEN_NAME.EMI_SELECTION,
        action: IMPRESSION_ACTIONS.IMPRESSION_EMI_SELECTION_PAGE,
        context: JSON.stringify({ ...context, businessLine: getBusinessLine(), category: SCREEN_NAME.EMI_SELECTION }),
    });
};

export const onEmiExpandClick = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        action: CLICK_ACTIONS.CLICK_EMI_EXPAND,
        category: SCREEN_NAME.EMI_SELECTION,
    });
};

export const onEmiTncClick = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        action: CLICK_ACTIONS.CLICK_EMI_TNC,
        category: SCREEN_NAME.EMI_SELECTION,
    });
};

export const onEmiProceedClick = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        action: CLICK_ACTIONS.CLICK_EMI_PROCEED,
        category: SCREEN_NAME.EMI_SELECTION,
    });
};

export const onEmiOptionClick = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        action: CLICK_ACTIONS.CLICK_EMI_OPTION,
        category: SCREEN_NAME.EMI_SELECTION,
    });
};
